"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
/*** node_modules **/
require("jquery.easing");
// import 'jquery.transit';
/*** ./modules **/
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("@fancyapps/fancybox");
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var object_fit_videos_1 = __importDefault(require("object-fit-videos"));
var header_1 = __importDefault(require("header"));
var menu_1 = __importDefault(require("menu"));
var hero_1 = __importDefault(require("hero"));
$(function () {
    new linker_1.default({
        extendLink: '.sw-ExtendLink'
    });
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .sol-Box_Link'
    });
    object_fit_images_1.default('img.sw-ObjectFit', { watchMQ: true });
    object_fit_videos_1.default(document.getElementById('heroVideo'));
    new header_1.default();
    new menu_1.default();
    new hero_1.default();
    $('.sol-Box_Link').fancybox({
        smallBtn: false,
        infobar: true,
        padding: 0,
        slideClass: '-business'
    });
});
